import React, { useState } from 'react';
import { 
    DatePicker,
    defaultDatePickerStrings, 
    DayOfWeek,
} from '@fluentui/react';
import moment from 'moment';

const dateFormat : string = "YYYY-MM-DD";
const userDateFormat : string = "DD/MM/YYYY";

interface IDatePickerComponentProps {
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
};

const DatePickerComponent = (props: IDatePickerComponentProps) => {
    const [dateValue, setDateValue] = useState<string>(props.value || "");

    const onSelectDate = (date?: Date | null) => {
        setDateValue(date ? moment(date).format(dateFormat) : "");
        props.onChange(date ? moment(date).format(dateFormat) : "");
    };

    const formatDate = (date?: Date) : string => {
        if (date) {
            return moment(date).format(userDateFormat);
        }
        else {
            return '';
        }
    };

    const parseDateFromString = (value: string) : Date | null => {
        return value ? moment(value, dateFormat).toDate() : null;
    };

    return (
        <DatePicker 
            allowTextInput={false}
            disabled={props.disabled}
            value={dateValue ? moment(dateValue, dateFormat).toDate() : undefined}
            onSelectDate={onSelectDate}
            formatDate={formatDate}
            parseDateFromString={parseDateFromString}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={defaultDatePickerStrings}
            placeholder="Fecha dd/mm/aaaa" />
    );
};

export default DatePickerComponent;
